import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreatePaymentMethod } from "../../../hooks/invoice/useCreatePaymentMethod";

const PaymentMethodsSeederDialog = ({ open = false, setOpen, successCallback }) => {

    const { t } = useTranslation('common');

    const defaultPaymentMethods = [
        {name: "Cash"},
        {name: "GCash"},
        {name: "E-Wallet"},
        {name: "Credt/Debit Card"},
        {name: "Bank Transfer"},
        {name: "Cheque"}
    ];
    
    const handleClose = (event, reason) => {
        // Prevent closing when clicking the backdrop or pressing Escape
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
        return;
        }
        setOpen(false);
    };

    const { create } = useCreatePaymentMethod(successCallback);

    const onConfirm = () => {
        createRecords();
        setOpen(false);
    }

    const createRecords = async () => {
        await create(defaultPaymentMethods);
    };

    return (
        <Dialog open={open} onClose={handleClose} disableRestoreFocus>
                <DialogTitle>
                    Invoice Module Initial Setup...
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">
                        Invoice module ready to use.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={onConfirm}
                    color="primary"
                    >
                    Close
                    </Button>
                </DialogActions>
        </Dialog>
  );
};

export default PaymentMethodsSeederDialog;